import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './admin.css';
import logo from '../assets/spartan.png';
import adminPhoto from '../assets/adminphoto.png';
import AddMemberModal from './GymMembers/AddMemberModal';
import AddPoolMemberModal from './PoolMembers/AddPoolMemberModal';
import { Avatar, Box, Typography, List, ListItem, ListItemIcon, ListItemText, Button, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { FitnessCenter as FitnessCenterIcon, ExpandMore as ExpandMoreIcon, Visibility as VisibilityIcon, PersonAdd as PersonAddIcon, Pool as PoolIcon, Search as SearchIcon } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';
import GymMembers from './GymMembers/GymMembers';
import PoolMembers from './PoolMembers/PoolMember';
import RecentlyDeleted from './RecentlyDeleted/RecentlyDeleted';
import RecentlyDeletedPool from './RecentlyDeleted/RecentlyDeletedPool';
import MemberSearch from './MemberSearch/MemberSearch';

const Sidebar = ({ setActiveComponent, isMobile, setSidebarVisible, visible, openModal, setIsPoolMemberModalOpen }) => {

  const handleItemClick = (component) => {
    if (component === 'AddGymMember') {
      openModal();
    } else if (component === 'AddPoolMember') {
      setIsPoolMemberModalOpen(true);
    } else {
      setActiveComponent(component);
    }
    if (isMobile) {
      setSidebarVisible(false);
    }
  };

  const sidebarClass = isMobile ? 'sidebar sidebar-mobile' : 'sidebar';
  const sidebarVisibleClass = isMobile && visible ? 'visible' : '';

  return (
    <Box className={`${sidebarClass} ${sidebarVisibleClass} sidebar-scrollbar`}>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: 2 }}>
        <Avatar src={adminPhoto} sx={{ width: 80, height: 80, border: '2px solid #16213e' }} />
        <Typography variant="h6" sx={{ marginTop: 1, color: '#e94560' }}>
          Meharbaan
        </Typography>
      </Box>
      <List>
        <ListItem button onClick={() => handleItemClick('MemberSearch')}>
          <ListItemIcon>
            <SearchIcon sx={{ color: '#ffffff' }} />
          </ListItemIcon>
          <ListItemText primary="Member Search & Profile" />
        </ListItem>
        <AccordionSection
          title="Gym Members"
          icon={<FitnessCenterIcon sx={{ color: '#ffffff' }} />}
          items={[
            { text: 'View Gym Members', component: 'ViewGymMembers' },
            { text: 'Add Gym Member', component: 'AddGymMember' },
          ]}
          handleItemClick={handleItemClick}
        />
        <AccordionSection
          title="Pool Members"
          icon={<PoolIcon sx={{ color: '#ffffff' }} />}
          items={[
            { text: 'View Pool Members', component: 'ViewPoolMembers' },
            { text: 'Add Pool Member', component: 'AddPoolMember' },
          ]}
          handleItemClick={handleItemClick}
        />
        <ListItem button onClick={() => handleItemClick('ViewDeleted')}>
          <ListItemIcon>
            <DeleteIcon sx={{ color: '#ffffff' }} />
          </ListItemIcon>
          <ListItemText primary="Recently Deleted Gym Member" />
        </ListItem>
        <ListItem button onClick={() => handleItemClick('ViewDeletedPool')}>
          <ListItemIcon>
            <DeleteIcon sx={{ color: '#ffffff' }} />
          </ListItemIcon>
          <ListItemText primary="Recently Deleted Pool Member" />
        </ListItem>
      </List>
      {isMobile && (
        <Button onClick={() => setSidebarVisible(false)} sx={{ color: '#ffffff', marginTop: 2 }}>
          Close Sidebar
        </Button>
      )}
    </Box>
  );
};

const AccordionSection = ({ title, icon, items, handleItemClick }) => (
  <Accordion sx={{ backgroundColor: 'transparent', color: '#ffffff' }}>
    <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#ffffff' }} />}>
      <ListItem component="div">
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText primary={title} />
      </ListItem>
    </AccordionSummary>
    <AccordionDetails>
      <List>
        {items.map((item, index) => (
          <ListItem button key={index} onClick={() => handleItemClick(item.component)}>
            <ListItemIcon>
              {item.text === 'Add Gym Member' || item.text === 'Add Pool Member' ? (
                <PersonAddIcon sx={{ color: '#ffffff' }} />
              ) : (
                <VisibilityIcon sx={{ color: '#ffffff' }} />
              )}
            </ListItemIcon>
            <ListItemText primary={item.text} />
          </ListItem>
        ))}
      </List>
    </AccordionDetails>
  </Accordion>
);

const ViewGymMembers = () => {
  const [todayMembersCount, setTodayMembersCount] = useState(0);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h2 style={{ margin: '0px' }}>Gym Members</h2>
        <div style={{
          backgroundColor: '#6d2057',
          color: 'white',
          padding: '8px 15px',
          borderRadius: '5px',
          fontSize: '14px'
        }}>
          Members Added Today: {todayMembersCount}
        </div>
      </div>
      <GymMembers setTodayMembersCount={setTodayMembersCount} />
    </div>
  );
};

const ViewDeleted = () => (
  <div>
    <h2 style={{ margin: '0px' }}>Recently Deleted Gym Members</h2>
    <RecentlyDeleted />
  </div>
);

const ViewDeletedPool = () => (
  <div>
    <h2 style={{ margin: '0px' }}>Recently Deleted Pool Members</h2>
    <RecentlyDeletedPool />
  </div>
);

const MemberSearchView = () => (
  <div>
    <MemberSearch />
  </div>
);

const ViewPoolMembers = () => (
  <div>
    <h2 style={{ margin: '0px' }}>Pool Members</h2>
    <PoolMembers />
  </div>
);

const AddGymMember = () => (
  <div>
    <h2>Add Member</h2>
    <AddMemberModal />
  </div>
);

const AddPoolMember = () => (
  <div>
    <h2>Add Pool Member</h2>
    <AddPoolMemberModal />
  </div>
);

function AdminDashboard() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const [isPoolMemberModalOpen, setIsPoolMemberModalOpen] = useState(false);
  const [activeComponent, setActiveComponent] = useState(() => {
    return localStorage.getItem('activeComponent') || 'ViewGymMembers';
  });
  
  useEffect(() => {
    const handleResize = () => {
      const isMobileView = window.innerWidth <= 768;
      setIsMobile(isMobileView);
      setSidebarVisible(false); // Keep sidebar closed by default
    };
    handleResize(); // Call immediately to set initial state
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  useEffect(() => {
    localStorage.setItem('activeComponent', activeComponent);
  }, [activeComponent]);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const toggleMenu = () => setSidebarVisible(!sidebarVisible);
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  const handleLogout = () => {
    localStorage.removeItem('session');
    window.location.href = '/';
  };

  const closePoolMemberModal = () => setIsPoolMemberModalOpen(false);

  const renderActiveComponent = () => {
    switch (activeComponent) {
      case 'ViewGymMembers':
        return <ViewGymMembers openModal={openModal} />;
      case 'ViewPoolMembers':
        return <ViewPoolMembers />;
      case 'AddGymMember':
        return <AddGymMember />;
      case 'AddPoolMember':
        return <AddPoolMember />;
      case 'ViewDeleted':
        return <ViewDeleted />;
      case 'ViewDeletedPool':
        return <ViewDeletedPool />;
      case 'MemberSearch':
        return <MemberSearchView />;
      default:
        return <ViewGymMembers />;
    }
  };

  return (
    <div className="admin-dashboard">
      <nav className="navbar1">
        <div className="navbar1-logo">
          <Link to="/admin-dashboard">
            <img src={logo} alt="Logo" />
          </Link>
        </div>
        <div className="navbar1-search">
          <div className={`hamburger1 ${sidebarVisible ? 'open' : ''}`} onClick={toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <ul className={`navbar-options1 ${sidebarVisible ? 'active' : ''}`}>
            <li className="profile-dropdown">
              <img src={adminPhoto} alt="User" onClick={toggleDropdown} />
              {dropdownOpen && (
                <ul className="dropdown-menu">
                  <li>
                    <button onClick={handleLogout}>Logout</button>
                  </li>
                </ul>
              )}
            </li>
          </ul>
        </div>
      </nav>

      <div className="admin-content" style={{ display: 'flex' }}>
        <Sidebar
          setActiveComponent={setActiveComponent}
          isMobile={isMobile}
          setSidebarVisible={setSidebarVisible}
          visible={sidebarVisible}
          openModal={openModal}
          setIsPoolMemberModalOpen={setIsPoolMemberModalOpen}
        />
        <div style={{ flexGrow: 1, padding: '20px' }}>{renderActiveComponent()}</div>
      </div>
      <AddMemberModal isOpen={isModalOpen} onClose={closeModal} />
      <AddPoolMemberModal isOpen={isPoolMemberModalOpen} onClose={closePoolMemberModal} />
    </div>
  );
}

export default AdminDashboard;
